import Offer from "types/Offer";

export const calculateOffersTotal = (offers: Partial<Offer>[]) => {
  return offers.reduce((total, offer) => {
    // Hardbundles are always free
    if (offer.type === "hardbundle") {
      return total;
    }

    // Total for trial offers
    if (offer.trial) {
      return total + Number(offer.marketplaceInfo?.trialInfo?.trialPrice || 0);
    }

    // Total for purchased offers
    return total + Number(offer?.marketplaceInfo?.price || 0);
  }, 0);
};
